/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both metric and imperial/US units are included across each category, including US customary units for volume.`)
};

const es_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se incluyen unidades métricas e imperiales/estadounidenses en cada categoría, incluyendo unidades consuetudinarias estadounidenses para volumen.`)
};

const de_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In jeder Kategorie sind sowohl metrische als auch imperiale/US-Einheiten enthalten, einschließlich der in den USA gebräuchlichen Einheiten für Volumen.`)
};

const nl_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zowel metrische als imperiale/US-eenheden zijn opgenomen in elke categorie, inclusief US-gebruikelijke eenheden voor volume.`)
};

const fr_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les unités métriques et impériales/américaines sont incluses dans chaque catégorie, y compris les unités courantes américaines pour le volume.`)
};

const it_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le unità metriche e imperiali/USA sono incluse in ogni categoria, incluse le unità consuetudinarie degli USA per il volume.`)
};

const pt_br2_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidades métricas e imperiais/US estão incluídas em cada categoria, incluindo unidades de costume US para volume.`)
};

const pt_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambas as unidades métricas e imperiais/americanas estão incluídas em cada categoria, incluindo unidades costumeiras americanas para volume.`)
};

const ja_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メートル法とヤード・ポンド法/米国単位がすべてのカテゴリに含まれており、体積には米国慣用単位も含まれています。`)
};

const zh_uc_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq3_a", locale)
	if (locale === "en") return en_uc_hub_faq3_a(inputs)
	if (locale === "es") return es_uc_hub_faq3_a(inputs)
	if (locale === "de") return de_uc_hub_faq3_a(inputs)
	if (locale === "nl") return nl_uc_hub_faq3_a(inputs)
	if (locale === "fr") return fr_uc_hub_faq3_a(inputs)
	if (locale === "it") return it_uc_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq3_a(inputs)
	if (locale === "pt") return pt_uc_hub_faq3_a(inputs)
	if (locale === "ja") return ja_uc_hub_faq3_a(inputs)
	return zh_uc_hub_faq3_a(inputs)
};